import React from 'react';

import { Footer, Header, PageLayout } from '../../components';
import PageContent from '../../features/Profile';
import { useAuthValidation } from '../../utils/hooks';

const ProfilePage = () => {
  useAuthValidation();

  return (
    <>
      <Header />
      <PageLayout>
        <PageContent />
      </PageLayout>
      <Footer />
    </>
  );
};

export default ProfilePage;
